/**************************************************
 * Nombre:       Detalle_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import imgDefecto from "../../Recursos/img_defecto.png";
import {theme} from "../../Tema";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {adap_producto} from "../../Modulo_Carrito_Wass/Adaptadores/adap_producto";
import {ShoppingCart} from "@mui/icons-material";
import {useFuncionesCarrito} from "../../Modulo_Carrito_Wass/Hooks/useFuncionesCarrito";
import 'photoswipe/dist/photoswipe.css'
import {Gallery, Item} from "react-photoswipe-gallery";
import {useEffect, useState} from "react";

const Detalle_Producto = ({item}) => {
    const {adicionarProducto, verificarProductoCarrito} = useFuncionesCarrito()
    const [imgs, setImgs] = useState([])


    useEffect(() => {

        let arr = []
        if (item.img) {
            arr.push(item.img)
        }

        if (item.imgs) {
            arr.push(...item.imgs)
        }
        console.log(arr)
        setImgs(arr)


    }, [item]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#FFF',
                strokeWidth: 0.5,
                stroke: 'rgba(0, 0, 0, 0.10)',
                filter: 'drop-shadow(0px 2px 20px rgba(0, 0, 0, 0.10))',
                p: 1,
                borderRadius: 1.5
            }}
        >


            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{zIndex: 1}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mb: -3.4, zIndex: 2}}>
                        {item.oferta === 'Si' &&
                            <Typography sx={{
                                backgroundColor: '#E4061350',
                                color: '#fff',
                                px: 3,
                                py: 0.1,
                                borderRadius: 1,
                                fontSize: 14,
                                fontWeight: 600
                            }}>Oferta</Typography>
                        }
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <img src={item.img ? item.img : imgDefecto} width={'100%'} height={'auto'}
                             style={{borderRadius: 4, marginBottom: 8}}/>
                    </Grid>


                </Grid>

            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 6}}
                sx={{p: 2}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{color: '#868686', fontSize: 16, fontWeight: 600}}>{item.marca}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                    <Typography
                        sx={{color: '#000000', fontSize: 20, fontWeight: 600, lineHeight: 1}}>{item.nombre}</Typography>
                </Grid>

                {item && item.descripcion &&
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                        <Typography
                            sx={{
                                color: '#00000090',
                                fontSize: 14,
                                fontWeight: 400,
                                lineHeight: 1
                            }}>{item.descripcion}</Typography>
                    </Grid>
                }

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                    <Typography sx={{
                        backgroundColor: theme.palette.primary.main + 40,
                        color: theme.palette.primary.main,
                        px: 2,
                        py: 0.1,
                        borderRadius: 1,
                        fontSize: 12,
                        fontWeight: 400
                    }}>{item.presentacion}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 6}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        {item && item.oferta === 'Si' && item.valorAntes &&
                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography
                                    sx={{
                                        color: '#00000080',
                                        fontSize: 14,
                                        fontWeight: 600
                                    }}>{`Antes: ${formatoMoneda(item.valorAntes)}`}</Typography>
                            </Grid>
                        }

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -0.5}}>
                            <Typography
                                sx={{
                                    color: '#000000',
                                    fontSize: 20,
                                    fontWeight: 600
                                }}>{formatoMoneda(item.valor)}</Typography>
                        </Grid>

                    </Grid>


                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1, justifyContent: 'flex-end'}}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mb: -1.5}}>
                            {verificarProductoCarrito(item) > 0 &&
                                <Typography
                                    sx={{
                                        fontSize: 16,
                                        color: theme.palette.primary.main
                                    }}>{`${verificarProductoCarrito(item)} en carrito`}</Typography>
                            }
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>

                            {(item.estado && item.estado === 'Sin Stock') || item.valor <= 0 ?
                                <Button
                                    disabled={true}
                                    fullWidth sx={{px: 1}}>
                                    Sin Stock
                                </Button>
                                :
                                <Button
                                    fullWidth
                                    onClick={() =>
                                        adicionarProducto(
                                            adap_producto({
                                                producto: item
                                            }))}

                                    startIcon={<ShoppingCart sx={{height: 18, width: 18}}/>}
                                    sx={{backgroundColor: theme.palette.primary.main, fontSize: 18}}
                                >Agregar</Button>
                            }


                        </Grid>

                    </Grid>

                </Grid>

            </Grid>

            <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: 'flex-start', mb: 1, mt: -1}}>
                <Gallery>
                    {imgs.map((it, index) => {
                        return (

                            <Item
                                original={it}
                                thumbnail={it}
                                width="620"
                                height="620"
                            >
                                {({ref, open}) => (
                                    <Grid container size={{xs: 3, sm: 3, md: 1}}
                                          sx={{m: 1}}>
                                        <img ref={ref} onClick={open} width={'100%'} src={it}
                                             style={{borderRadius: 5}}
                                        />
                                    </Grid>

                                )}
                            </Item>


                        )
                    })}

                </Gallery>
            </Grid>

        </Grid>
    )

}
export default Detalle_Producto